import React, { useState, useContext, useEffect } from "react";
import Select from 'react-select';
import { Calendar } from "primereact/calendar";
import { useTranslation } from "react-i18next";
import { DataContext } from "../App";
import { useNavigate } from 'react-router-dom';

const BookNowMobile = (props) => {
  const { t } = useTranslation();
  const context = useContext(DataContext);
  const navigate = useNavigate();
  const [destination, setDestination] = useState('');
  const [checkInDate, setCheckinDate] = useState(null);
  const [checkOutDate, setCheckOutDate] = useState(null);
  const [guests, setGuests] = useState(0);
  const [canSearch, setCanSearch] = useState(false);

  const areaOptions = context.properties && context.properties.filter(x => x.status === "active").reduce((acc, property) => {
    if (!acc.some(option => option.value === property.address.area)) {
      acc.push({ value: property.address.area, label: property.address.area });
    }
    return acc;
  }, []);

  const guestOptions = Array.from(
    { length: context.properties && context.properties.filter(x => x.status === "active").reduce((max, property) => Math.max(max, property.guests || 1), 0) },
    (_, i) => ({ value: i + 1, label: (i + 1).toString() })
  );


  useEffect(() => {
    if (destination && checkInDate && checkOutDate && guests) {
      setCanSearch(true);
    }
  }, [destination, checkInDate, checkOutDate, guests]);

  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };

  return (
    <div className={"row book-now-mobile mt-4"} id="book-now-mobile">
      <hr className="text-white mb-5"/>
      <div className="col-12">
        <h4 className={`mb-4 pb-3 text-center title text-white text-uppercase`}> {t("BookStay")}</h4>
      </div>
      <div className="col-md-6 col-12 text-left mb-3">
        <label className={`label-book-modal mt-4 mb-2 text-white text-uppercase`}>{t("Destination")}</label>
        <Select
          value={areaOptions && destination ? areaOptions.find(x => x.value === destination) : null}
          onChange={(e) => setDestination(e.value)}
          className="w-full bg-transparent text-black custom-select hover-select-elements-black-bg"
          options={areaOptions}
          placeholder={t("SelectDestination")}
        />
      </div>
      <div className="col-md-6 col-12 text-left mb-3">
        <label className={`label-book-modal mt-4 text-white mb-2 text-uppercase`}>{t("NumberOfGuest")}</label>
        <Select
          value={guestOptions && guests ? guestOptions.find(x => x.value === guests) : null}
          isSearchable={false}
          onChange={(e) => {
            setGuests(e.value)
          }}
          className="w-full bg-transparent text-black custom-select"
          options={guestOptions}
          placeholder={t("AddGuestSelect")}
        />
      </div>
      <div className="col-md-6 col-6 mt-4 flex-column d-flex text-left mb-3">
        <label className={`label-book-modal mb-1 text-white text-uppercase`}>{t("Checkin")}</label>
        <Calendar
          value={checkInDate}
          onChange={(e) => {
            setCheckinDate(e.value);
            setCheckOutDate(null);
          }}
          inputClassName={`input-calendar-custom w-full my-0 pb-0`}
          className={`mb-2 w-full custom-select my-2`}
          placeholder={t('dd/mm/yy')}
          dateFormat="dd/mm/yy"
          selectionMode="single"
          minDate={addDays(new Date(Date.now()), 1)}
          viewDate={checkInDate ? checkInDate : new Date(Date.now())}
          readOnlyInput={true}
        />
      </div>
      <div className="col-md-6 col-6 mt-4 flex-column d-flex text-left mb-3">
        <label className={`label-book-modal mb-1 text-white text-uppercase`}>{t("Checkout")}</label>
        <Calendar
          value={checkOutDate}
          onChange={(e) => setCheckOutDate(e.value)}
          inputClassName={`input-calendar-custom w-full`}
          className={`mb-2 w-full custom-select my-2`}
          placeholder={t('dd/mm/yy')}
          dateFormat="dd/mm/yy"
          selectionMode="single"
          minDate={addDays(checkInDate, 1)}
          viewDate={checkOutDate ? checkOutDate : checkInDate}
          readOnlyInput={true}
        />
      </div>
      <div className="col-12 d-flex mt-4 justify-content-center">
      <button disabled={!canSearch} onClick={(e) => {
        e.preventDefault();
        if (props.closeMenu) props.closeMenu();
        navigate("/property-collection", { state: { searchedCheckIn: checkInDate, searchedCheckOut: checkOutDate, searchedGuests: guests, searchedDestination: destination } });
      }}
        className={`btn-book-now-mobile mt-3 py-3 px-3`}>
        {t("CheckAvailability")}
      </button>
      </div>
    </div>
  );
};

export default BookNowMobile;
